<template>
  <div>
    <div
      class="local-wrapper"
      :style="{
        background: slideData.background_color,
        color: slideData.text_color,
      }"
    >
      <div
        v-if="slideData.include_copy"
        class="local-description-box"
        v-html="slideData.slide_text"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feature_4',
  props: {
    slideData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.local-wrapper {
  position: fixed;
  height: 50%;
  width: 50%;
}
.local-description-box {
  color: inherit;
  text-align: left;
  /* padding-left: 100px;
  padding-top: 50px; */
  font-size: 70px;
  margin: 10%;
  /* width: 90%; */
}
</style>
